<template>
  <div class="h-full flex flex-col">
    <div class="flex mb-10px flex-wrap">
      <el-input
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请输入关键字"
        v-model="searchData.keywords"
        clearable
      ></el-input>
      <el-select
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请选择区域"
        v-model="searchData.areaId"
        clearable
      >
        <el-option
          v-for="item in areaList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <department-select
        ref="departmentSelect"
        class="mr-10px !w-50 mb-10px"
        v-model="searchData.ownedUnitId"
      ></department-select>
      <!-- <el-select
        v-model="searchData.troubleshootType"
        size="small"
        class="mr-10px !w-50"
        placeholder="请选择排查类型"
        clearable
      >
        <el-option
          v-for="item in checkTypeList"
          :key="item.value"
          :label="item.displayName"
          :value="Number(item.code)"
        ></el-option>
      </el-select> -->
      <el-select
        v-model="searchData.jobActivityType"
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请选择作业类型"
        clearable
      >
        <el-option
          v-for="item in jobTypeList"
          :key="item.value"
          :label="item.displayName"
          :value="Number(item.code)"
        ></el-option>
      </el-select>
      <el-button class="mb-10px" size="small" type="primary" @click="searchList">搜索</el-button>
      <el-button class="mb-10px" size="small" @click="resetText">重置</el-button>
      <!-- 根据产品需求先隐藏功能 -->
      <!-- <el-button size="small" @click="handleEvent(null, 'export')" :disabled="!$hasAccess('export')"
        >导出</el-button
      > -->
    </div>
    <div class="flex-auto h-0px">
      <el-table
        :span-method="spanMethod"
        ref="table"
        :data="tableData"
        border
        class="w-full"
        :height="tableHeight"
        stripe
        v-loading="loading"
        @selection-change="handleSelection"
      >
        <!-- <el-table-column type="selection" width="50"></el-table-column> -->
        <el-table-column label="序号" prop="index" width="50"></el-table-column>
        <el-table-column
          label="作业活动名称"
          min-width="180"
          prop="jobName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          min-width="120"
          label="作业类型"
          prop="jobActivityType"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ jobTypeMap(scope.row.jobActivityType) }}
          </template>
        </el-table-column>
        <el-table-column
          min-width="120"
          label="作业活动编号"
          prop="jobNo"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          min-width="120"
          label="所属区域"
          prop="jobActivityAreaStr"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          min-width="120"
          label="实施单位"
          prop="jobImplementationUnitStr"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          min-width="120"
          label="管控层级"
          prop="controlHierarchyText"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          min-width="120"
          label="责任单位"
          prop="organizationUnitName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          min-width="120"
          label="责任人"
          prop="leaderName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          min-width="120"
          label="作业步骤"
          prop="jobStep"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          min-width="150"
          label="危险源或潜在事件"
          prop="hiddenEvent"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          min-width="150"
          label="可能导致事故类型"
          prop="accidentType"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column
          min-width="120"
          label="隐患排查内容"
          prop="screeningContent"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          min-width="120"
          label="排查类型"
          prop="screeningType"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ checkTypeMap(scope.row.screeningType) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="120"
          label="排查周期"
          prop="inspectionCycle"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ checkCycleText(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="修改人"
          prop="updateUserName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button
              size="mini"
              :disabled="!$hasAccess('update')"
              @click="handleEvent(scope.row, 'update')"
              >编辑</el-button
            >
            <el-button
              size="mini"
              @click.native="handleEvent(scope.row, 'read')"
              :disabled="!$hasAccess('read')"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="searchList"
        @current-change="findList"
        :current-page.sync="pageNo"
        :page-size.sync="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :total="total"
        class="float-right mt-20px ml-10px"
      ></el-pagination>
    </div>

    <CheckListJobForm
      v-if="formDialog"
      :formProps="formProps"
      :formData="formData"
      @refreshList="refreshList"
      @cancel="formDialog = false"
    ></CheckListJobForm>
  </div>
</template>

<script>
import { AreaApi } from '@wiz-api/area-management'
import { HiddenDangerInspectionChecklistControllApi } from '@wiz-api/double-prevention-management'
import uuid from 'uuid'
import DepartmentSelect from '@/components/safety/DepartmentSelect/DepartmentSelect'
import utils from '@/components/safety/enumField/utils'

import CheckListJobForm from './CheckListJobForm'

const hiddenDangerInspectionChecklistControllApi = new HiddenDangerInspectionChecklistControllApi()

const areaApi = new AreaApi()
export default {
  name: 'check-list-job-table',
  components: {
    CheckListJobForm,
    DepartmentSelect,
  },
  beforeUpdate() {
    this.$nextTick(() => {
      this.$refs.table.doLayout()
    })
  },
  filters: {},
  data() {
    return {
      FormData: {},
      formDialog: false,
      formProps: {
        visible: false,
        // create 新增 update 编辑 read 详情
        pageType: 'create',
      },
      areaList: [],
      jobTypeList: [],
      checkTypeList: [],
      unitCycleList: [],
      // 作业活动清单
      tableData: [],
      loading: false,
      searchData: {
        type: '',
        readStatus: '',
        title: '',
      },
      total: 0,
      pageNo: 1,
      pageSize: 15,
      selectionData: [],

      position: 0,
      spanArrObj: {},
    }
  },
  created() {
    this.searchList()
    this.getAreaList()
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.JobActivityType',
        'DoublePreventionManagement.DataCategory.CheckType',
        'DoublePreventionManagement.DataCategory.UnitCycle',
      ],
      ['jobTypeList', 'checkTypeList', 'unitCycleList'],
      this
    )
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 54px)'
    },
    jobTypeMap() {
      return (val) => {
        return (
          this.jobTypeList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    checkTypeMap() {
      return (val) => {
        return (
          this.checkTypeList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    checkCycleText() {
      return (row) => {
        if (row.inspectionCycle && `${row.unitCycle}`) {
          const unit =
            this.unitCycleList.find((i) => {
              // eslint-disable-next-line eqeqeq
              return i.code == row.unitCycle
            })?.displayName || ''
          return `${row.inspectionCycle}${unit}`
        }
        return ''
      }
    },
  },
  methods: {
    resetText() {
      this.searchData = this.$options.data().searchData
      this.$refs.departmentSelect.userName = ''
      this.searchList()
    },
    searchList() {
      this.pageNo = 1
      this.findList()
    },
    // 选中
    handleSelection(values) {
      this.selectionData = values.map((item) => {
        return item.jobActivityId
      })
    },
    async findList() {
      this.selectionData = []
      this.loading = true
      const searchData = utils.deleteFormField(this.searchData)
      const data = {
        skipCount: (this.pageNo - 1) * this.pageSize,
        maxResultCount: this.pageSize,
        ...searchData,
      }
      const [err, res] = await hiddenDangerInspectionChecklistControllApi.getHomeworkActivitiesList(
        data
      )

      if (!err) {
        this.tableData = this.toList(res.items)
        this.getSpanArr()
        this.total = res.totalCount
        this.loading = false
      }
    },

    toList(list) {
      return list.reduce((pre, item, index) => {
        item.mergeId = uuid()
        const data = item.jobSourcesDangerIdentifyAssessDtos
        if (data && data.length) {
          data.forEach((i) => {
            i.index = index + 1
            pre.push({
              ...i,
              ...item,
            })
          })
        } else {
          item.index = index + 1
          pre.push(item)
        }
        return pre
      }, [])
    },
    getSpanArr() {
      this.position = 0
      this.spanArrObj = {}
      const needSpan = ['mergeId']
      needSpan.forEach((item) => {
        this.rowspan(item)
      })
    },
    // 获取合并行参数(数组)
    rowspan(prop) {
      this.tableData.forEach((item, index) => {
        if (index === 0) {
          if (!this.spanArrObj[prop]) {
            this.spanArrObj[prop] = []
          }
          this.spanArrObj[prop].push(1)
          this.position = 0
        } else if (this.tableData[index][prop] === this.tableData[index - 1][prop]) {
          this.spanArrObj[prop][this.position] += 1
          this.spanArrObj[prop].push(0)
        } else {
          if (!this.spanArrObj[prop]) {
            this.spanArrObj[prop] = []
          }
          this.spanArrObj[prop].push(1)
          this.position = index
        }
      })
    },
    // 合并行方法
    spanMethod({ row, column, rowIndex, columnIndex }) {
      if ([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 17].includes(columnIndex)) {
        const _row = this.spanArrObj.mergeId[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col,
        }
      }
      return {
        rowspan: 1,
        colspan: 1,
      }
    },
    refreshList() {
      this.formDialog = false
      this.findList()
    },
    // 列表操作-事件
    handleEvent(row = null, operation) {
      switch (operation) {
        case 'delete':
          this.$confirm('是否删除该记录？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              const [err, res] = await xxx.xxx(row.id)
              if (!err) {
                this.$message.success('删除成功')
                this.findList()
              }
            })
            .catch(() => {})
          break
        case 'read':
          this.initDialog(row, operation)
          break
        case 'update':
          this.initDialog(row, operation)
          break
        case 'export':
          if (!this.selectionData || this.selectionData.length === 0) {
            this.$message({
              showClose: true,
              message: '请勾选要导出的记录',
              type: 'warning',
            })
            return
          }
          this.export()
          break
        default:
          break
      }
    },
    async export() {
      const [err, res] = await hiddenDangerInspectionChecklistControllApi.exprtJobActivityDataList({
        guids: this.selectionData,
        returnType: 'Blob',
      })
      if (!err) {
        this.downLoadExcel('作业活动排查清单数据', res)
        this.$message({
          showClose: true,
          message: '导出成功',
          type: 'success',
        })
      }
    },
    downLoadExcel(fileName = '下载文件', data) {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `${fileName}`
      link.click()
      window.URL.revokeObjectURL(link.href)
    },
    // 弹窗初始化操作
    initDialog(row, operation) {
      // 没有新增获取数据
      this.taskId = row.id
      this.formProps.editType = operation
      this.formData = this.$options.data().formData
      this.formData = row
      this.formDialog = true
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
  },
}
</script>

<style></style>
